import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as workSpacesActions from './actions';
import { WorkSpacesService } from '@app/shared/services/workspaces/workspaces.service';
import { Store } from '@ngrx/store';
import { IWorkspace } from './workspaces-model';
import { Injectable } from '@angular/core';
import { RootStoreState } from '..';

@Injectable()
export class WorkspaceStoreEffects {
  workspacesObject = this.store$.select('workspaces');

  constructor(
    private workSpacesService: WorkSpacesService,
    private actions$: Actions,
    private store: Store,
    private store$: Store<RootStoreState.State>
  ) {}
  getWorkSpace$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(workSpacesActions.ActionTypes.GET_WORKSPACES),
      switchMap(() =>
        this.workSpacesService.getWorkSpaces().pipe(
          map((data) => workSpacesActions.getWorkspacesSuccess({ payload: data })),
          catchError((error) => of(workSpacesActions.getWorkspacesFailure({ error })))
        )
      )
    )
  );

  getWorkSpaceInvite$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<workSpacesActions.Actions>(workSpacesActions.ActionTypes.GET_WORKSPACES_INVITES),
      switchMap(() =>
        this.workSpacesService.getWorkSpaceInvites().pipe(
          map((data) => {
            return workSpacesActions.getWorkspacesInvitesSuccess({ payload: data });
          }),
          catchError((error) => {
            return of(workSpacesActions.getWorkspacesInvitesFailure({ error }));
          })
        )
      )
    )
  );

  deleteWorkSpace$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(workSpacesActions.ActionTypes.DELETE_WORKSPACE),
      switchMap((action: workSpacesActions.Actions & { workspaceId: string }) => {
        return this.workSpacesService.deleteWorkSpace(action.workspaceId).pipe(
          map((id) => {
            this.store.dispatch(workSpacesActions.getWorkspacesRequest());
            return workSpacesActions.deleteWorkspaceSuccess({ workspaceId: id });
          }),
          catchError((error) => {
            return of(workSpacesActions.deleteWorkspaceFailure({ error }));
          })
        );
      })
    )
  );

  updateWorkSpaceInvite$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(workSpacesActions.ActionTypes.UPDATE_WORKSPACES_INVITES),
      switchMap((action: { workspace_id: string; invite_response: 'accept' | 'decline'; type: string }) =>
        this.workSpacesService
          .updateWorkSpaceInvites({
            workspace_id: action.workspace_id,
            invite_response: action.invite_response,
          })
          .pipe(
            map((data) => {
              if (action.invite_response !== 'accept') {
                this.store.dispatch(workSpacesActions.getWorkspacesInvitesRequest());
              }
              setTimeout(() => {
                this.store.dispatch(workSpacesActions.resetWorkspacesInvitesRequest());
              }, 5000);
              return workSpacesActions.updateWorkspacesInvitesSuccess({ payload: data });
            }),
            catchError((error) => {
              return of(workSpacesActions.updateWorkspacesInvitesFailure({ error }));
            })
          )
      )
    )
  );
}
